<span
  class="block text-left f-9"
  [ngClass]="{ 'leading-tight': compactMode }"
  [style.textDecoration]="statusId == StatusEnum.INACTIVE ? 'line-through' : 'none'"
  [style.textDecorationColor]="statusId == StatusEnum.INACTIVE ? 'red' : 'inherit'"
>
  <!-- Used Unit (only if different from base unit) -->
  <ng-container *ngIf="shouldShowUsedUnit">
    <span
      [matTooltip]="showTooltips ? usedUnitTooltip : ''"
      [matTooltipDisabled]="!showTooltips"
    >
      {{ getFormattedQuantity(usedUnit?.quantity) }} ({{ usedUnit?.unitName }})
    </span>
    <br />
  </ng-container>

  <!-- Base Unit (UMB) - Always displayed -->
  <span
    [matTooltip]="showTooltips ? baseUnitTooltip : ''"
    [matTooltipDisabled]="!showTooltips"
  >
    <b>UMB:</b>
    {{ getFormattedQuantity(baseUnit?.quantity) }} ({{ baseUnit?.unitName }})
  </span>

  <!-- Parallel Unit (UMP) - Conditionally displayed -->
  <ng-container *ngIf="shouldShowUMP">
    <br />
    <span
      [matTooltip]="showTooltips ? parallelUnitTooltip : ''"
      [matTooltipDisabled]="!showTooltips"
    >
      <b>UMP:</b>
      <ng-container *ngIf="parallelUnit && isValidQuantity(parallelUnit.quantity); else noUMPData">
        {{ getFormattedQuantity(parallelUnit?.quantity) }} ({{ parallelUnit?.unitName }})
      </ng-container>
    </span>
  </ng-container>

  <!-- Template for missing UMP data -->
  <ng-template #noUMPData> - </ng-template>
</span>
